import { useTranslation } from 'react-i18next'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { ModalMessage, compactModalOverrides } from './styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const DeleteAddressBlockedModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation()
  const isPulse = usePulseScope()

  return (
    <SDModal
      isOpen={isOpen}
      openHandler={onClose}
      title={t('subscriptionForm:address_module.delete_address.blocked_title')}
      overrides={compactModalOverrides}
      sections={
        isPulse ? (
          <SDNotification
            type='warning'
            primaryText={t('subscriptionForm:address_module.delete_address.blocked_message')}
          />
        ) : (
          <ModalMessage>{t('subscriptionForm:address_module.delete_address.blocked_message')}</ModalMessage>
        )
      }
    />
  )
}

export default DeleteAddressBlockedModal
